<template>
	<Dialog :open="isOpen" @close="handleClosed" class="relative z-[9999999]" @keydown.esc="handleClosed">
		<div class="fixed inset-0 bg-black/50" aria-hidden="true" />
		<div class="fixed inset-0 flex w-screen min-h-screen items-center justify-center !p-4">
			<DialogPanel
				:class="[
					'w-full overflow-y-scroll max-h-screen max-w-sm bg-primary_alt !p-4 relative',
					panelClass,
					isInvisible && 'invisible',
				]"
			>
				<button type="button" aria-label="Close Dialog" class="absolute top-2 right-2" @click="handleClosed">
					<svg-vue icon="close" class="w-4" />
				</button>
				<DialogTitle
					v-if="title"
					:class="['seint-text-primary text-lg font-bold', titleClass, killTitlePadding ? '!p-0 !m-0' : '!pb-4']"
				>
					{{ title }}
				</DialogTitle>
				<DialogDescription v-if="description">{{ description }}</DialogDescription>
				<slot name="content" />
			</DialogPanel>
		</div>
	</Dialog>
	<slot v-if="!hideBtn" name="button">
		<button type="button" :class="btnClass" :disabled="disabled" :aria-label="btnText" @click="() => setIsOpen(true)">
			<slot name="icon" /><span>{{ btnText }}</span>
		</button>
	</slot>
	<button v-if="hybridBtn" type="button" :class="btnClass" :aria-label="btnText" @click="() => setIsOpen(true)">
		<slot name="button" />
	</button>
</template>

<script setup>
import { ref, watch } from 'vue'
import { Dialog, DialogPanel, DialogTitle, DialogDescription } from '@headlessui/vue'

const props = defineProps({
	id: {
		type: String,
		required: true,
	},
	panelClass: {
		type: String,
		default: '',
	},
	title: {
		type: String,
		default: null,
	},
	titleClass: {
		type: String,
		default: '',
	},
	killTitlePadding: {
		type: Boolean,
		default: false,
	},
	description: {
		type: String,
		default: null,
	},
	btnText: {
		type: String,
		default: 'Submit',
	},
	btnClass: {
		type: String,
		default: '',
	},
	hideBtn: {
		type: Boolean,
		default: false,
	},
	hybridBtn: {
		type: Boolean,
		default: false,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	autoShow: {
		type: Boolean,
		default: false,
	},
})

const emit = defineEmits(['closed', 'opened'])

const isOpen = ref(props.autoShow)
const isInvisible = ref(null)

watch(isOpen, (hasOpened) => {
	if (hasOpened) emit('opened')
})

const setIsOpen = (value) => (isOpen.value = value)
const setInvisible = (value) => (isInvisible.value = value)

const handleClosed = () => {
	setInvisible(false)
	setIsOpen(false)
	emit('closed')
}

defineExpose({ setIsOpen, setInvisible })
</script>
